export default "__VITE_ASSET__CHDhMMyk__"